import React from 'react';

import L from 'leaflet';

import { Marker } from 'react-leaflet-universal';

import * as stagePoints from '../../../data/stage-points.json';
import * as startPoints from '../../../data/start-points.json';

import './MapMarkers.css';

const createStartStagePoint = zoom => {
  const iconSize = zoom <= 5 ? 30 : 30;
  const stagePoint = new L.Icon({
    iconUrl: require('../../../assets/images/relay-change.svg'),
    iconRetinaUrl: require('../../../assets/images/relay-change.svg'),
    iconSize: [iconSize, iconSize],
  })
  return stagePoint;
}

const createStagePoint = stageNo => {
  const iconSize = 60;
  return new L.Icon({
    iconUrl: require(`../../../assets/images/stages/stage${stageNo}.svg`),
    iconRetinaUrl: require(`../../../assets/images/stages/stage${stageNo}.svg`),
    iconSize: [iconSize, iconSize],
  })
}

const createStartPoints = zoom => {
  let parent = [];
  startPoints.default.data.forEach((item, idx) => {
    parent.push(<Marker key={`m_${idx}`} position={item} icon={createStartStagePoint(zoom)}> </Marker>);
  });
  return parent;
}

const createStagePoints = zoom => {
  let parent = [];
  if (zoom > 4) {
    stagePoints.default.data.forEach((item, idx) => {
      parent.push(<Marker key={`sp_${idx}`} position={item} icon={createStagePoint(idx + 1, zoom)}> </Marker>);
    });
  }
  return parent;
}

const MapMarkers = props => {
  return (<span>
    {/* {createStartPoints(props.zoom)} */}
    {createStagePoints(props.zoom)}
    {/* <Marker position={props.currentPosition} icon={indicatorIcon}></Marker> */}
    {/* <PoiMarker position={[50.5729079, 21.6790698]} counter={20}></PoiMarker> */}
    {/* <PoiMarker position={[50.52441, 21.62468]} counter={1}></PoiMarker> */}
  </span>)
}

export { MapMarkers as default }